import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import api from "@/lib/api";
import { streamChat, newSid } from "@/lib/aiStream";

export function useAiChat({ storageKey, streamPath, historyPath, owner }) {
  const [sid, setSid] = useState(() => localStorage.getItem(storageKey) || newSid());
  const [messages, setMessages] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    localStorage.setItem(storageKey, sid);
    const load = owner ? api.get(`${historyPath}/${sid}`).then((r) => r.data) : fetch(`${API}${historyPath}/${sid}`).then((r) => r.json());
    load.then((d) => setMessages(Array.isArray(d) ? d : [])).catch(() => {});
  }, [sid, storageKey, historyPath, owner]);

  const send = async (text) => {
    const t = text.trim();
    if (!t || busy) { return; }
    setError("");
    setBusy(true);
    setMessages((m) => [...m, { role: "user", content: t }, { role: "assistant", content: "" }]);
    try {
      await streamChat(streamPath, { session_id: sid, message: t }, (chunk) =>
        setMessages((m) => { const c = [...m]; c[c.length - 1] = { role: "assistant", content: c[c.length - 1].content + chunk }; return c; }));
    } catch (e) {
      setError(e.message);
      setMessages((m) => m.slice(0, -1));
    }
    setBusy(false);
  };

  const reset = () => { setMessages([]); setSid(newSid()); };
  return { messages, busy, error, send, reset };
}
